import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RoleMenu from "@/components/feature/RoleMenu";
import UserMenu from "@/components/feature/UserMenu";
import Logo from "@/components/feature/Logo";
import MobileSearch from "./MobileSearch";
import { useAuth } from "@/hooks/useAuth";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";

export default function MobileAppBar() {
  const [scrolled, setScrolled] = useState(false);
  const { user, role } = useAuth();
  const { settings } = useSiteSettingsContext();
  const name = settings.siteName || "DersDinle";
  const fullName =
    String(user?.user_metadata?.ad_soyad ?? "").trim() ||
    (user?.email ? user.email.split("@")[0] : "");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="lg:hidden bg-background-50 border-b border-background-200">
      {/* Üst duyuru bandı — gradyan, kaydırınca kaybolur */}
      <Link
        to="/paketler"
        className={`block overflow-hidden transition-[max-height,opacity] duration-300 ${
          scrolled ? "max-h-0 opacity-0" : "max-h-9 opacity-100"
        }`}
        aria-label="Ücretsiz paketle başla"
      >
        <div className="h-9 px-4 flex items-center justify-center gap-2 bg-gradient-to-r from-primary-600 to-accent-600 text-background-50">
          <i className="ri-sparkling-2-line text-sm" aria-hidden="true"></i>
          <span className="text-xs font-semibold whitespace-nowrap truncate">
            Ücretsiz paketle başla
          </span>
          <i className="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
        </div>
      </Link>

<a href="/downloads/DersdinleMobil.html" className="flex min-h-10 items-center justify-center bg-[#302942] px-4 py-2 text-xs font-semibold text-[#d4edaa]">Android uygulamasını indir ↓ · DersdinleMobil 2.20.0</a>
      <Link to="/programlarimiz" className="flex min-h-10 items-center justify-center border-b border-slate-200 text-sm font-semibold text-primary-700">Programlarımız · Kurulum ve kullanım rehberi →</Link>
      {/* Ana bar */}
      <div className="flex items-center gap-1.5 h-14 px-3 sm:px-4">
        <Link
          to="/"
          className="flex items-center shrink-0"
          aria-label={`${name}.com ana sayfa`}
        >
          <Logo variant="light" size="sm" />
        </Link>

        <MobileSearch />

        {user ? (
          <div className="shrink-0">
            <UserMenu name={fullName} role={role} />
          </div>
        ) : (
          <>
            <Link
              to="/kayit"
              aria-label="ücretsiz başla"
              className="inline-flex items-center justify-center gap-1.5 h-11 w-11 sm:w-auto sm:px-4 rounded-md sm:rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 active:scale-[0.97] transition-all shrink-0"
            >
              <i className="ri-rocket-2-line text-base" aria-hidden="true"></i>
              <span className="hidden sm:inline text-sm font-semibold whitespace-nowrap">
                Ücretsiz Dene
              </span>
            </Link>

            <div className="shrink-0">
              <RoleMenu />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
